import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
export function BonosSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-20" aria-labelledby="bonos" data-id="element-21" data-mp="185xhj0pe4ry8">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-22" data-mp="13cmktsealrk1">
        <div data-id="element-23" data-mp="yf2z67f9mci2">
          <p className="flex items-center gap-2 font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" data-id="element-24" data-mp="yfmdle5piirc">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="tgjcg4sukwon" />
            5 Bonos estratégicos
          </p>
          <h2 id="bonos" className="mt-3 max-w-2xl font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-26" data-mp="of3qmaiuim57">
            Siempre incluidos — activan el sistema desde el día uno
          </h2>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="2etmd4o0n46e2">
          {bonos.map(bono => <li key={bono.number} className="flex flex-col rounded-xl border border-ink-800 bg-ink-950 p-6" data-id="element-28" data-mp="29tq76j8du4vv">
              <span className="font-display text-3xl font-900 leading-none text-ink-600" data-id="element-29" data-mp="qxirov2rs1i2">
                {bono.number}
              </span>
              <h3 className="mt-4 font-display text-lg font-800 leading-snug text-white" data-id="element-30" data-mp="hv9e1wc7fs0g">
                {bono.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-31" data-mp="mucl1mbqw8b2">{bono.description}</p>
              <p className="mt-auto flex items-baseline gap-2 pt-5" data-id="element-32" data-mp="1ajx7if73xnp3">
                <span className="text-sm text-slate-500 line-through" data-id="element-33" data-mp="1el8mzrw9osjk">{bono.price}</span>
                <span className="font-display text-sm font-800 uppercase tracking-wide text-leaf-400" data-id="element-34" data-mp="10u3v5bz554js">
                  Gratis
                </span>
              </p>
            </li>)}

          <li className="flex flex-col justify-center rounded-xl border border-gold bg-ink-800 p-6" data-id="element-35" data-mp="1thpycj4gi764">
            <p className="text-xs font-600 uppercase tracking-[0.2em] text-slate-300" data-id="element-36" data-mp="1y9hrn1ezyqzy">
              Valor total de los 5 bonos
            </p>
            <p className="mt-2 font-display text-4xl font-900 text-gold" data-id="element-37" data-mp="284gcwm76xw9n">$89 USD</p>
            <p className="mt-3 text-sm leading-relaxed text-slate-200" data-id="element-38" data-mp="2376on9vjfqne">
              → Gratis con tu Código Solar 360°
            </p>
          </li>
        </ul>
      </div>
    </section>;
}